module.exports = __webpack_public_path__ + "img/green_106.42e65567.png";